import { InfiniteSlider } from "@/components/ui/infinite-slider";

const BANKS = [
  { name: "Chase", domain: "chase.com" },
  { name: "Bank of America", domain: "bankofamerica.com" },
  { name: "Wells Fargo", domain: "wellsfargo.com" },
  { name: "Citibank", domain: "citi.com" },
  { name: "Capital One", domain: "capitalone.com" },
  { name: "US Bank", domain: "usbank.com" },
  { name: "PNC Bank", domain: "pnc.com" },
  { name: "TD Bank", domain: "td.com" },
  { name: "HSBC", domain: "hsbc.com" },
  { name: "Barclays", domain: "barclays.com" },
  { name: "Santander", domain: "santander.com" },
  { name: "Deutsche Bank", domain: "db.com" },
  { name: "Lloyds Bank", domain: "lloydsbank.com" },
  { name: "NatWest", domain: "natwest.com" },
  { name: "RBC", domain: "rbc.com" },
  { name: "ANZ", domain: "anz.com" },
  { name: "Westpac", domain: "westpac.com.au" },
  { name: "ING", domain: "ing.com" },
  { name: "BNP Paribas", domain: "bnpparibas.com" },
  { name: "Truist", domain: "truist.com" },
  { name: "Regions Bank", domain: "regions.com" },
  { name: "BMO", domain: "bmo.com" },
  { name: "KeyBank", domain: "key.com" },
  { name: "Fifth Third", domain: "53.com" },
];

export default function BankLogoCloud() {
  return (
    <section className="border-y border-[#1e0d01]/8 bg-white py-8">
      <div className="mb-6 text-center">
        <p className="text-xs font-medium uppercase tracking-[0.2em]" style={{ color: "rgba(30,13,1,0.4)" }}>
          Works with statements from 100+ banks including
        </p>
      </div>

      <InfiniteSlider gap={24} speed={40} speedOnHover={10} className="w-full">
        {BANKS.map((bank) => (
          <div
            key={bank.name}
            className="group inline-flex flex-col items-center gap-2 rounded-[12px] border border-[#1e0d01]/8 bg-white px-5 py-3 shadow-sm min-w-[110px] hover:border-primary/30 transition-colors"
          >
            <img
              src={`https://logo.clearbit.com/${bank.domain}`}
              alt={`${bank.name} logo`}
              className="h-7 w-auto object-contain grayscale opacity-60 transition-all duration-300 group-hover:opacity-100 group-hover:[filter:sepia(1)_saturate(5)_hue-rotate(-20deg)]"
              onError={(e) => {
                (e.currentTarget as HTMLImageElement).style.display = "none";
              }}
            />
            <span className="text-xs font-medium whitespace-nowrap" style={{ color: "rgba(30,13,1,0.5)" }}>
              {bank.name}
            </span>
          </div>
        ))}
      </InfiniteSlider>
    </section>
  );
}
